<script setup>
defineProps({
  row: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <a
    :href="`/app/accounts/${$route.params.accountId}/conversations/${row.original.id}`"
    class="text-n-slate-12 hover:underline"
    target="_blank"
    rel="noopener noreferrer nofollow"
  >
    #{{ row.original.id }}
  </a>
</template>
